import React, { useState, useEffect } from 'react';
import './result.scss';
import { tLoader } from '@/Utils/i18n';
import { languageManager } from '@/Utils/languageManager';

const translations = {
    en: {
        "Payment Failed": "Payment Failed",
        "Your payment could not be processed.": "Your payment could not be processed.",
        "Common Issues": "Common Issues",
        "Your card was declined by the issuing bank": "Your card was declined by the issuing bank",
        "Insufficient funds in your account": "Insufficient funds in your account",
        "Incorrect card information was provided": "Incorrect card information was provided",
        "The transaction was flagged as suspicious by your bank": "The transaction was flagged as suspicious by your bank",
        "Need Help?": "Need Help?",
        "If you continue to experience issues, please contact our support team at": "If you continue to experience issues, please contact our support team at",
        " support@koreanmate.app": " support@koreanmate.app",
        "Try Again": "Try Again",
        "Return to Home": "Return to Home"
    },
    id: {
        "Payment Failed": "Pembayaran Gagal",
        "Your payment could not be processed.": "Pembayaran Anda tidak dapat diproses.",
        "Common Issues": "Masalah Umum",
        "Your card was declined by the issuing bank": "Kartu Anda ditolak oleh bank penerbit",
        "Insufficient funds in your account": "Dana tidak mencukupi di akun Anda",
        "Incorrect card information was provided": "Informasi kartu yang diberikan tidak benar",
        "The transaction was flagged as suspicious by your bank": "Transaksi ditandai sebagai mencurigakan oleh bank Anda",
        "Need Help?": "Butuh Bantuan?",
        "If you continue to experience issues, please contact our support team at": "Jika Anda terus mengalami masalah, silakan hubungi tim dukungan kami di",
        " support@koreanmate.app": " support@koreanmate.app",
        "Try Again": "Coba Lagi",
        "Return to Home": "Kembali ke Beranda"
    },
    ko: {
        "Payment Failed": "결제 실패",
        "Your payment could not be processed.": "결제를 처리할 수 없습니다.",
        "Common Issues": "일반적인 문제",
        "Your card was declined by the issuing bank": "카드가 발급 은행에 의해 거부되었습니다",
        "Insufficient funds in your account": "계정에 잔액이 부족합니다",
        "Incorrect card information was provided": "잘못된 카드 정보가 제공되었습니다",
        "The transaction was flagged as suspicious by your bank": "거래가 은행에 의해 의심스러운 것으로 표시되었습니다",
        "Need Help?": "도움이 필요하신가요?",
        "If you continue to experience issues, please contact our support team at": "문제가 계속되면 다음 주소로 지원팀에 문의하세요:",
        " support@koreanmate.app": " support@koreanmate.app",
        "Try Again": "다시 시도",
        "Return to Home": "홈으로 돌아가기"
    },
    vn: {
        "Payment Failed": "Thanh toán Thất bại",
        "Your payment could not be processed.": "Thanh toán của bạn không thể được xử lý.",
        "Common Issues": "Vấn đề Thường gặp",
        "Your card was declined by the issuing bank": "Thẻ của bạn đã bị ngân hàng phát hành từ chối",
        "Insufficient funds in your account": "Không đủ tiền trong tài khoản của bạn",
        "Incorrect card information was provided": "Thông tin thẻ được cung cấp không chính xác",
        "The transaction was flagged as suspicious by your bank": "Giao dịch đã được ngân hàng của bạn đánh dấu là đáng ngờ",
        "Need Help?": "Cần Giúp đỡ?",
        "If you continue to experience issues, please contact our support team at": "Nếu bạn tiếp tục gặp sự cố, vui lòng liên hệ với đội ngũ hỗ trợ của chúng tôi tại",
        " support@koreanmate.app": " support@koreanmate.app",
        "Try Again": "Thử lại",
        "Return to Home": "Quay lại Trang chủ"
    }
};

const PaymentFailed: React.FC = () => {
    const [, forceUpdate] = useState({});
    const t = tLoader(translations);

    useEffect(() => {
        const unsubscribe = languageManager.subscribe(() => forceUpdate({}));
        return unsubscribe;
    }, []);

    // Get query parameters
    const queryParams = new URLSearchParams(window.location.search);
    const errorMessage = queryParams.get('error') || t('Your payment could not be processed.');

    return (
        <div className="payment-result-page failed">
            <header className="page-header">
                <div className="logo-container">
                    <img src="/logo-white.svg" alt="Korean Mate Logo" className="header-logo" />
                </div>
            </header>

            <div className="result-container">
                <div className="result-icon failed">
                    <svg viewBox="0 0 24 24" width="64" height="64">
                        <circle cx="12" cy="12" r="11" fill="#F44336" stroke="white" strokeWidth="2" />
                        <path d="M8 8l8 8M16 8l-8 8" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" />
                    </svg>
                </div>

                <h1 className="result-title">{t("Payment Failed")}</h1>

                <div className="result-details">
                    <p className="result-message">
                        {errorMessage}
                    </p>

                    <div className="troubleshooting">
                        <h2>{t("Common Issues")}</h2>
                        <ul>
                            <li>{t("Your card was declined by the issuing bank")}</li>
                            <li>{t("Insufficient funds in your account")}</li>
                            <li>{t("Incorrect card information was provided")}</li>
                            <li>{t("The transaction was flagged as suspicious by your bank")}</li>
                        </ul>
                    </div>

                    <div className="help-info">
                        <h2>{t("Need Help?")}</h2>
                        <p>
                            {t("If you continue to experience issues, please contact our support team at")}
                            <a href="mailto:support@koreanmate.app">{t(" support@koreanmate.app")}</a>.
                        </p>
                    </div>
                </div>

                <div className="action-buttons">
                    <a href="/product/korean-session" className="retry-button">
                        {t("Try Again")}
                    </a>
                    <a href="/" className="home-button">
                        {t("Return to Home")}
                    </a>
                </div>
            </div>
        </div>
    );
};

export default PaymentFailed;